import { __rest } from "tslib";
import React, { useCallback, useMemo, useState } from 'react';
import useMergedInputProps from './useMergedInputProps';
import { baseFormFieldPropTypes } from './BaseFormFieldPropTypes';
import './BaseFormField.less';
import renderBaseField from './renderBaseField';
import SensitiveFieldWrapper from './SensitiveFieldWrapper';
const ALWAYS_VALID = () => undefined;
function BaseFormField(props) {
    const { label, isDummy = false, name, required = false, emptyMessage, description, component, inputProps, fieldProps, id, noTopSpacer, className, disabled, validate = ALWAYS_VALID, delay = 0, minimum = 2, canSubmit = false, type, showLabel = true, hideErrorAlert = false, value, labelComponent, isEqual, hideCharacterCount = false, isSensitive = false, buttonLabelShow, buttonLabelHide } = props, otherProps = __rest(props, ["label", "isDummy", "name", "required", "emptyMessage", "description", "component", "inputProps", "fieldProps", "id", "noTopSpacer", "className", "disabled", "validate", "delay", "minimum", "canSubmit", "type", "showLabel", "hideErrorAlert", "value", "labelComponent", "isEqual", "hideCharacterCount", "isSensitive", "buttonLabelShow", "buttonLabelHide"]);
    const [showContent, setShowContent] = useState(false);
    const handleToggleShow = useCallback(() => {
        setShowContent((current) => !current);
    }, []);
    const censored = isSensitive && !showContent;
    const fieldConfig = useMemo(() => ({
        name,
        disabled,
        //When isDummy is true, we override any validation that's passed in from the component parameter or elsewhere
        validate: isDummy ? ALWAYS_VALID : validate,
        required,
        emptyMessage,
        id,
        description,
        inputProps,
        fieldProps,
        type,
        label,
        value,
        isDummy,
        isEqual,
        hideCharacterCount,
        censored,
    }), [
        name,
        disabled,
        validate,
        required,
        emptyMessage,
        id,
        description,
        inputProps,
        fieldProps,
        type,
        label,
        value,
        isDummy,
        isEqual,
        hideCharacterCount,
        censored,
    ]);
    const _a = useMergedInputProps(fieldConfig), { errorId } = _a, mergedInputProps = __rest(_a, ["errorId"]);
    if (isDummy)
        mergedInputProps.value = undefined;
    const fieldError = mergedInputProps.error;
    const baseField = renderBaseField(Object.assign({ className,
        noTopSpacer,
        id,
        showLabel,
        label,
        required,
        labelComponent,
        mergedInputProps,
        fieldConfig,
        description,
        hideErrorAlert,
        fieldError,
        delay,
        minimum,
        canSubmit,
        component,
        errorId }, otherProps));
    return isSensitive ? (React.createElement(SensitiveFieldWrapper, { inputId: id, onToggle: handleToggleShow, showContent: showContent, buttonLabelShow: buttonLabelShow, buttonLabelHide: buttonLabelHide }, baseField)) : (baseField);
}
BaseFormField.propTypes = baseFormFieldPropTypes;
export default React.memo(BaseFormField);
//# sourceMappingURL=BaseFormField.js.map